import { render, staticRenderFns } from "./coach_group_detail_youth.vue?vue&type=template&id=e8a091d2&"
import script from "./coach_group_detail_youth.vue?vue&type=script&lang=js&"
export * from "./coach_group_detail_youth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports